import { Actions } from '../../interfaces'
import { Car } from '@/entities/public'

import find from './find'

export const actions: Actions = {
  find,
}

export default {
  Model: { Car },
  actions: { [Car.name]: actions },
}
